import { DatePipe, Location } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  GdsCalendarService,
  IGetMonthProps,
} from '@upr-web-primer/gds-calendar';
import { LocaleService } from '@upr-web-primer/locale';
import { NotificationService } from '@upr-web-primer/notification';
import { LocalStorageService } from '@upr-web-primer/storage';
import { filter, map } from '@upr-web-primer/udx-utils';
import { UdxSpinnerService } from '@upr-web-primer/udx-spinner';
import { WINDOW } from '@upr-web-primer/window';
import { DateTime } from 'luxon';
import { CookieService } from 'ngx-cookie-service';
import { forkJoin, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonUtilityService } from '../../services/common-utility.service';
import lostFoundLanguageData from '../../shared/constants/lost-found-label.json';
@Component({
  selector: 'app-lost-found-web-form',
  templateUrl: './lost-found-web-form.component.html',
  styleUrls: ['./lost-found-web-form.component.scss'],
  standalone: false,
})
export class LostFoundWebFormComponent implements OnInit, AfterViewInit {
  pageLabels: any;
  @Input() lostFoundWebForm: FormGroup;
  nameRegex = this.namePattern.NAME_SIGNUP;
  subscriptions = new Subscription();
  firstNameErrorMsgInfo: string;
  lastNameErrorMsgInfo: string;
  emailErrorMsgInfo: string;
  reEnterEmailErrorMsgInfo: string;
  inputChanged: boolean;
  agreeConditionSelected: boolean;
  countAgreeSelected: boolean;
  privacyAgreeSelected: boolean;
  lostFoundWebFormData: any;
  calendarOutputInfo: any;
  datePickerMonths: any;
  gdsDatePickerCalendarInfo: {
    shortWeekdays: any;
    data: { defaultDate: { dayInfo: any } };
    timezone: any;
  };
  currentMonthObj: any;
  datePickerData: boolean;
  selectedDate: any;
  postalPin: any;
  postalErrorMsg: any;
  validPostalResponse: any;
  prefectureDetailsInfo: any;
  selectedPrefectureList: any;
  cityErrorMsg: string;
  prefectureErrorMsg: string;
  townErrorMsg: string;
  showPrefectureDropdownOptions: { label: any; value: any }[];
  firstNameFurginaErrorMsgInfo: string;
  lastNameFurginaErrorMsgInfo: string;
  phoneNumberErrorInfo: string;
  lostTimeErrorInfo: string;
  lostLocErrorInfo: string;
  checkboxValue: boolean;
  streetErrorMsg: string;
  lostPropertyRadioButtons: { label: any; value: number }[];
  selectedLostItemRadio: boolean;
  selectedLostPropertyRadio: boolean;
  detailsOfLostLocErrorInfo: any;
  patchingDate: string | null;
  selectionDate = false;
  disableSendBtn = false;
  lostFoundCreation = true;
  lostFoundConfirmPage: boolean;
  dobErrorInfo: string;
  dob: any;
  formattedDate: string;
  localeInfo: import('@upr-web-primer/locale').Locale;
  mainCategoryRadioButtons: any;
  monthData: import('@upr-web-primer/gds-calendar').MonthOutputType;
  mockDataMainCategories: any[];
  mockDataSubCategories: any;
  mockLostItemCase: any;
  mockLostItemColor: any;
  leftColumnRadioButtons: any[] = [];
  rightColumnRadioButtons: any[] = [];
  subCategoryItems: any;

  subCategoryLeft: any[] = [];
  subCategoryRight: any[] = [];

  functionOptionsCategoryLeft: any[] = [];
  functionOptionsCategoryRight: any[] = [];

  carrierOptionsCategoryLeft: any[] = [];
  carrierOptionsCategoryRight: any[] = [];
  optionsCategoryItems: any;
  options2CategoryItems: any;
  functionOptionsCategoryItems: any;
  carrierOptionsCategoryItems: any;
  isCategorySelected: boolean;

  subCategoryOptions: any[] = [];

  selectedRadioFlags: boolean[] = [];
  isSubmitButtonEnabled = false;
  lostFoundLanguageData: any = lostFoundLanguageData;
  subCategoryOptionsMap: { [key: string]: { left: any[]; right: any[] } } = {};
  subCategoryData: any[] = [];
  selectedOptions: { [key: string]: { optionId: string; optionName: string } } =
    {};

  selectedRadioValues: { [groupName: string]: string } = {};
  hidePostalButton = false;
  isFormSubmittedSuccessfully: any;
  retrieveLostFoundFormData: any;
  @ViewChild('datePickerRef') datePickerRef: any;
  constructor(
    public common: CommonUtilityService,
    public formBuilder: FormBuilder,
    @Inject('NamePattern') public namePattern: any,
    @Inject('Ranges') public ranges: any,
    @Inject('GlobalDefaults') public globalDefault: any,
    public cdRef: ChangeDetectorRef,
    @Inject('EmailPasswordPattern') public emailRegex: any,
    @Inject('AppDefaults') public appDefault: any,
    private readonly datePipe: DatePipe,
    @Inject(WINDOW) public window: Window,
    private readonly cdr: ChangeDetectorRef,
    private readonly cookieService: CookieService,
    public notification: NotificationService,
    private readonly locale: LocaleService,
    private readonly location: Location,
    @Inject('AppRoutes') private readonly appRoutes: any,
    private readonly gdsCalendarService: GdsCalendarService,
    private readonly localStorage: LocalStorageService,
    private readonly spinner: UdxSpinnerService,
  ) {
    this.pageLabels = this.common.getResolvedPageData();
  }

  ngAfterViewInit(): void {
    const today = this.datePipe?.transform(new Date(), 'yyyy-MM-dd');

    setTimeout(() => {
      if (this.datePickerRef) {
        this.datePickerRef.value = today;
      }
    });
  }
  /**
   * ngOnInit - It will load all the functions
   */
  ngOnInit(): void {
    this.hidePostalButton = true;
    this.lostPropertyRadioButtons = [
      {
        label: this.pageLabels?.['lostForm.property_found_park'],
        value: 752510000,
      },
      {
        label: this.pageLabels?.['lostForm.property_found_mail'],
        value: 752510001,
      },
    ];
    this.common.OIDCTokenAnonymous();
    this.common.anonymousData$.subscribe((res: any) => {
      if (res?.length > 1) {
        this.loadPrefecture();
        this.mainCategories();
      }
    });
    this.common.getMockPrefectureData().subscribe((data: any) => {
      if (data && !this.prefectureDetailsInfo) {
        this.hidePostalButton = false;
      }
    });
    const date = new Date();
    this.createForm();
    this.retrieveLostFoundFormData = this.common.getFormData();
    if (this.retrieveLostFoundFormData?.controls) {
      const formData = this.retrieveLostFoundFormData;

      this.lostFoundWebForm.patchValue({
        agree: formData?.value?.agree,
        countAgree: formData?.value?.countAgree,
        privacyAgree: formData?.value?.privacyAgree,
        lastName: formData?.value?.lastName,
        last_name_furgina: formData?.value?.last_name_furgina,
        firstName: formData?.value?.firstName,
        first_name_furgina: formData?.value?.first_name_furgina,
        email: formData?.value?.email,
        reEnterEmail: formData?.value?.reEnterEmail,
        phoneNumber: formData?.value?.phoneNumber,
        postalCode: formData?.value?.postalCode,
        prefecture: formData?.value?.prefecture,
        city: formData?.value?.city,
        town: formData?.value?.town,
        street: formData?.value?.street,
        dob: formData?.value?.dob,
        lostTime: formData?.value?.lostTime,
        lostLocation: formData?.value?.lostLocation,
        selectedLostItemButton: formData?.value?.selectedLostItemButton,
        detailLostItem: formData?.value?.detailLostItem,
        selectedLostPropertyButton: formData?.value?.selectedLostPropertyButton,
        selectedOption: formData?.value?.selectedOption,
        mainCategoryId: formData?.value?.mainCategoryId,
      });
      this.selectedLostItemRadio = true;
      this.selectedLostPropertyRadio = true;
      this.isSubmitButtonEnabled = true;
      this.selectionDate = true;

      this.selectedDate = this.localStorage.getItem('selectedDate');
      this.dob = this.selectedDate;
      this.lostFoundWebForm.get('dob')?.patchValue(this.selectedDate);

      this.getCurrentDateObj();
      this.isFormSubmittedSuccessfully = this.common.getFormSubmitted();
      if (this.common.getConfirmPage() && !this.isFormSubmittedSuccessfully) {
        this.subCategories(formData?.value?.mainCategoryId);
      }
    }
    if (this.isFormSubmittedSuccessfully) {
      this.lostFoundWebForm.reset();
      this.subCategoryItems = [];
      this.subCategoryOptions = [];
      this.dob = '';
      this.selectedDate = '';
      this.lostFoundWebForm.get('dob')?.patchValue(this.dob);
      this.getCurrentDateObj();
      this.common.setFormData('');
      this.notification.hide();
    }
    this.getFormData();
    const firstDate: any = new Date(date.getFullYear(), date.getMonth() - 3, 1);
    const lastDate: any = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.getCurrentDateObj();
    this.getCalenderInfo(
      this.datePipe?.transform(firstDate, 'yyyy-MM-dd'),
      this.datePipe?.transform(lastDate, 'yyyy-MM-dd'),
    );
  }

  patchFormSubCategory(): any {
    const formData = this.retrieveLostFoundFormData;
    const subcategoriesArray = this.lostFoundWebForm.get(
      'subcategories',
    ) as FormArray;
    subcategoriesArray.clear();

    if (
      subcategoriesArray.length === 0 &&
      formData?.value?.subcategories &&
      Array.isArray(formData?.value?.subcategories)
    ) {
      formData.value.subcategories.forEach((item: any) => {
        subcategoriesArray.push(
          this.formBuilder.group({
            selectedOption: [item.selectedOption],
            selectedOptionId: [item.selectedOptionId],
            subCategoryName: [item.subCategoryName],
          }),
        );
      });
    }
    this.lostFoundWebForm.patchValue({
      subCategories: subcategoriesArray?.value,
    });
  }

  /**
   * mainCategories - Get the main categories from API and displaying in UI based on udx_order number
   */
  mainCategories(): any {
    this.common
      .getMainCategoryData(this.globalDefault?.LOST_AND_FOUND)
      .subscribe(
        (data: any) => {
          this.mainCategoryRadioButtons = data?.value;
          this.mainCategoryRadioButtons?.sort(
            (a: any, b: any) => a?.udx_ordernumber - b?.udx_ordernumber,
          );
          this.splitRadioButtons();
          // OnPush ancestor (AppComponent) won't see this async update without marking dirty
          this.cdRef.markForCheck();
        },
        (error: any) => {
          console.error(error);
        },
      );
  }

  /**
   * splitRadioButtons - split the main categories with left and right
   */
  splitRadioButtons(): void {
    this.leftColumnRadioButtons = [];
    this.rightColumnRadioButtons = [];

    this.mainCategoryRadioButtons.forEach((item: any, index: number) => {
      if (index % 2 === 0) {
        this.leftColumnRadioButtons.push(item);
      } else {
        this.rightColumnRadioButtons.push(item);
      }
    });
  }
  /**
   * createForm - create the form
   */

  createForm(): void {
    this.lostFoundWebForm = this.formBuilder.group({
      agree: new FormControl('', [Validators.requiredTrue]),
      countAgree: new FormControl('', [Validators.requiredTrue]),
      privacyAgree: new FormControl('', [Validators.requiredTrue]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.maxLength(30),
        this.noWhitespaceValidator(),
        Validators.pattern(this.nameRegex),
      ]),
      last_name_furgina: new FormControl('', [
        Validators.required,
        Validators.maxLength(30),
        this.noWhitespaceValidator(),
        Validators.pattern(this.nameRegex),
      ]),
      firstName: new FormControl('', [
        Validators.required,
        Validators.maxLength(25),
        Validators.pattern(this.nameRegex),
        this.noWhitespaceValidator(),
      ]),
      first_name_furgina: new FormControl('', [
        Validators.required,
        Validators.maxLength(25),
        Validators.pattern(this.nameRegex),
        this.noWhitespaceValidator(),
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailRegex.EMAIL),
      ]),
      reEnterEmail: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailRegex.EMAIL),
      ]),
      phoneNumber: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(11),
      ]),
      postalCode: new FormControl('', [
        <any>Validators.required,
        Validators.minLength(7),
        Validators.maxLength(20),
        this.noWhitespaceValidator(),
      ]),
      prefecture: new FormControl('', [
        Validators.required,
        Validators.maxLength(120),
        this.noWhitespaceValidator(),
      ]),
      city: new FormControl('', [
        Validators.required,
        Validators.maxLength(50),
        this.noWhitespaceValidator(),
      ]),
      town: new FormControl('', [
        Validators.required,
        Validators.maxLength(50),
        this.noWhitespaceValidator(),
      ]),
      street: new FormControl('', [
        Validators.required,
        Validators.maxLength(100),
      ]),
      dob: new FormControl('', [Validators.required]),
      lostTime: new FormControl('', [Validators.required]),
      lostLocation: new FormControl('', [Validators.required]),
      selectedLostItemButton: new FormControl(''),
      detailLostItem: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(2000),
        this.common.isOnlyWhitespace(),
      ]),
      selectedLostPropertyButton: new FormControl('', [Validators.required]),
      selectedOption: new FormControl(''),
      mainCategoryId: [''],

      subcategories: this.formBuilder.array([]),
    });
    this.addSubcategories();
  }

  /**
   * addSubcategories - Dynamically add subcategory to the FormArray
   * Define subCategoryOptions as an array, with each item containing leftOptions and rightOptions
   */
  addSubcategories(): void {
    const localeInfo = this.locale.getFromUrl();
    const languageCode = localeInfo.language;

    const field = this.lostFoundLanguageData[languageCode];
    const subcategoriesArray = this.lostFoundWebForm.get(
      'subcategories',
    ) as FormArray;
    subcategoriesArray.clear();

    this.subCategoryItems?.forEach((subCategory: any) => {
      const subCategoryNameField = field.sub_category;
      const selectedOption = subCategory.selectedOption || null;
      const selectedOptionId = subCategory.selectedOptionId || null;

      // Create a FormGroup for each subcategory
      const subCategoryGroup = this.formBuilder.group({
        selectedOption: new FormControl(selectedOption),
        selectedOptionId: new FormControl(selectedOptionId),
        subCategoryName: [subCategory[subCategoryNameField] || ''],
      });

      // Add the FormGroup to the FormArray
      subcategoriesArray.push(subCategoryGroup);
    });
  }

  /**
   * createSeparateArraysForSubcategories - creating the all the categories and options in single array
   */
  createSeparateArraysForSubcategories(): any {
    this.subCategoryOptions = [];

    this.subCategoryData?.forEach((subCategoryData: any) => {
      const subCategory = subCategoryData?.subCategory;
      const leftOptions = subCategoryData?.leftOptions;
      const rightOptions = subCategoryData?.rightOptions;

      // Construct the object in the desired format
      const subCategoryObject: any = {
        subCategory: subCategory,
        leftOptions: leftOptions,
        rightOptions: rightOptions,
      };

      // Push the structured object to the subCategoryOptions array
      this.subCategoryOptions?.push(subCategoryObject);
    });
  }

  /**
   * noWhitespaceValidator
   * @returns
   */

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace =
        (control.value || '')?.trim()?.length ===
        this.ranges.PASSWORDS.INDEX[0];
      return isWhitespace ? { whitespace: true } : null;
    };
  }

  /**
   * getErrorMessageInfo - Validations of each field
   * @param event - event
   */
  getErrorMessageInfo(event: any): void {
    const fieldInfo = event?.target?.id;
    switch (fieldInfo) {
      case this.globalDefault.POSTALCODE:
        if (event?.target?.value?.length !== this.ranges?.MAX?.POSTALCODE) {
          this.cdRef.detectChanges();
          return (this.postalErrorMsg = this.pageLabels?.['errCode.E013']);
        } else {
          this.selectedPrefectureList = '';
          this.postalErrorMsg = '';
        }
        break;
      case this.globalDefault.FIRSTNAME:
        this.lostFoundWebForm.value.firstName =
          this.lostFoundWebForm.value.firstName?.trim();

        const firstNameValue = this.lostFoundWebForm.value.firstName;
        if (firstNameValue?.length > this.ranges.MAX.FIRST_NAME) {
          this.lostFoundWebForm.controls[this.globalDefault.FIRSTNAME].setValue(
            this.lostFoundWebForm.value.firstName.substring(
              0,
              this.ranges.MAX.FIRST_NAME,
            ),
          );
        }
        this.firstNameErrorMsgInfo = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.LASTNAME:
        this.lostFoundWebForm.value.lastName =
          this.lostFoundWebForm.value.lastName?.trim();
        const lastNameValue = this.lostFoundWebForm.value.lastName;
        if (lastNameValue?.length > this.ranges.MAX.LAST_NAME) {
          this.lostFoundWebForm.controls[this.globalDefault.LASTNAME].setValue(
            this.lostFoundWebForm.value.lastName.substring(
              0,
              this.ranges.MAX.LAST_NAME,
            ),
          );
        }
        this.lastNameErrorMsgInfo = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.FURGINA_FIRSTNAME:
        this.lostFoundWebForm.value.first_name_furgina =
          this.lostFoundWebForm.value.first_name_furgina?.trim();

        const firstNameFurginaValue =
          this.lostFoundWebForm.value.first_name_furgina;
        if (firstNameFurginaValue?.length > this.ranges.MAX.FIRST_NAME) {
          this.lostFoundWebForm.controls[
            this.globalDefault.FURGINA_FIRSTNAME
          ].setValue(
            this.lostFoundWebForm.value.first_name_furgina.substring(
              0,
              this.ranges.MAX.FIRST_NAME,
            ),
          );
        }
        this.firstNameFurginaErrorMsgInfo = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.FURGINA_LASTNAME:
        this.lostFoundWebForm.value.last_name_furgina =
          this.lostFoundWebForm.value.last_name_furgina?.trim();

        const lastNameFurginaValue =
          this.lostFoundWebForm.value.last_name_furgina;
        if (lastNameFurginaValue?.length > this.ranges.MAX.FIRST_NAME) {
          this.lostFoundWebForm.controls[
            this.globalDefault.FURGINA_LASTNAME
          ].setValue(
            this.lostFoundWebForm.value.last_name_furgina.substring(
              0,
              this.ranges.MAX.FIRST_NAME,
            ),
          );
        }
        this.lastNameFurginaErrorMsgInfo = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.EMAIL:
        const emailValue = this.lostFoundWebForm.value.email;
        if (emailValue?.length >= this.ranges.MAX.EMAIL) {
          this.lostFoundWebForm.controls[this.globalDefault.EMAIL].setValue(
            this.lostFoundWebForm.value.email.substring(
              0,
              this.ranges.MAX.EMAIL,
            ),
          );
        }
        this.emailErrorMsgInfo = this.getErrorMessage(fieldInfo);
        break;
      case 'reEnterEmail':
        const reEnterEmailValue = this.lostFoundWebForm.value.reEnterEmail;
        if (reEnterEmailValue?.length >= this.ranges.MAX.EMAIL) {
          this.lostFoundWebForm.controls['reEnterEmail'].setValue(
            this.lostFoundWebForm.value.reEnterEmail.substring(
              0,
              this.ranges.MAX.EMAIL,
            ),
          );
        }
        this.reEnterEmailErrorMsgInfo = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.PHONENUMBER:
        this.phoneNumberErrorInfo = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.PREFECTURE:
        this.prefectureErrorMsg = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.CITY:
        this.cityErrorMsg = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.TOWN:
        this.townErrorMsg = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.STREET:
        this.streetErrorMsg = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.LOST_TIME:
        this.lostTimeErrorInfo = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.LOST_LOCATION:
        this.lostLocErrorInfo = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.DETAILS_OF_LOST_ITEM:
        this.detailsOfLostLocErrorInfo = this.getErrorMessage(fieldInfo);
        break;
      case this.globalDefault.DOB:
        this.dobErrorInfo = this.getErrorMessage(fieldInfo);
        break;
    }
    this.cdRef.detectChanges();
  }
  /**
   * getErrorMessage - Validations for each field
   * @param field
   * @returns
   */
  getErrorMessage(field: any): string {
    const fieldName = this.lostFoundWebForm?.get(field);
    const emptyCheck = this.pageLabels?.['errCode.E001'];
    const regex = /\s/;
    if (regex.test(this.lostFoundWebForm.value[field]))
      this.lostFoundWebForm.value[field] = '';

    if (field === 'reEnterEmail') {
      // Checking re-enter email
      if (!this.lostFoundWebForm.value.reEnterEmail) return emptyCheck;
      else if (
        this.lostFoundWebForm.value.reEnterEmail?.length <
          this.ranges.MAX.EMAIL &&
        this.lostFoundWebForm.value.reEnterEmail.match(
          this.emailRegex.EMAIL_SIGNUP,
        ) == null
      ) {
        return this.pageLabels?.['errCode.E021'];
      } else if (
        this.lostFoundWebForm.value.email !==
        this.lostFoundWebForm.value.reEnterEmail
      ) {
        this.inputChanged = false;
        this.reEnterEmailErrorMsgInfo = this.pageLabels?.['errCode.E030'];
        return this.reEnterEmailErrorMsgInfo;
      }
    }

    if (field === this.globalDefault.EMAIL) {
      if (!this.lostFoundWebForm.value.email) return emptyCheck;
      else if (
        this.lostFoundWebForm.value.email?.length < this.ranges.MAX.EMAIL &&
        this.lostFoundWebForm.value.email.match(this.emailRegex.EMAIL_SIGNUP) ==
          null
      ) {
        return this.pageLabels?.['errCode.E021'];
      } else if (
        this.lostFoundWebForm.value.email?.length < this.ranges.MAX.EMAIL
      ) {
        return '';
      } else {
        return this.pageLabels?.['errCode.E021'];
      }
    }

    fieldName?.markAsTouched();

    if (!fieldName?.valid && (fieldName?.dirty || fieldName?.touched)) {
      return this.getErrorInfo(field);
    }
    this.cdRef.detectChanges();
    return '';
  }
  /**
   * getErrorInfo()
   * @param field Input field
   * @returns Error message
   */
  getErrorInfo(field: any): any {
    const emptyCheck = this.pageLabels?.['errCode.E001'];
    switch (field) {
      case this.globalDefault.FIRSTNAME: {
        if (!this.lostFoundWebForm.value.firstName) return emptyCheck;
        else if (
          this.lostFoundWebForm.value.firstName?.length <
          this.ranges.MAX.FIRST_NAME
        ) {
          return '';
        } else {
          this.firstNameErrorMsgInfo =
            this.pageLabels?.['errCode.E020'] +
            ' ' +
            this.ranges.MAX.FIRST_NAME +
            ' ' +
            this.pageLabels?.['createAccount.maxCharCheck'];
          return this.firstNameErrorMsgInfo;
        }
      }
      case this.globalDefault.LASTNAME: {
        if (!this.lostFoundWebForm.value.lastName) return emptyCheck;
        else if (
          this.lostFoundWebForm.value.lastName?.length <
          this.ranges.MAX.LAST_NAME
        ) {
          return '';
        } else {
          this.lastNameErrorMsgInfo =
            this.pageLabels?.['errCode.E020'] +
            ' ' +
            this.ranges.MAX.LAST_NAME +
            ' ' +
            this.pageLabels?.['createAccount.maxCharCheck'];
          return this.lastNameErrorMsgInfo;
        }
      }
      case this.globalDefault.FURGINA_LASTNAME: {
        if (!this.lostFoundWebForm.value.last_name_furgina) return emptyCheck;
        else if (
          this.lostFoundWebForm.value.last_name_furgina?.length <
          this.ranges.MAX.FIRST_NAME
        ) {
          return '';
        } else {
          this.firstNameFurginaErrorMsgInfo =
            this.pageLabels?.['errCode.E020'] +
            ' ' +
            this.ranges.MAX.FIRST_NAME +
            ' ' +
            this.pageLabels?.['createAccount.maxCharCheck'];
          return this.firstNameFurginaErrorMsgInfo;
        }
      }
      case this.globalDefault.FURGINA_FIRSTNAME: {
        if (!this.lostFoundWebForm.value.first_name_furgina) return emptyCheck;
        else if (
          this.lostFoundWebForm.value.first_name_furgina?.length <
          this.ranges.MAX.FIRST_NAME
        ) {
          return '';
        } else {
          this.lastNameFurginaErrorMsgInfo =
            this.pageLabels?.['errCode.E020'] +
            ' ' +
            this.ranges.MAX.FIRST_NAME +
            ' ' +
            this.pageLabels?.['createAccount.maxCharCheck'];
          return this.lastNameFurginaErrorMsgInfo;
        }
      }
      case this.globalDefault.PHONENUMBER: {
        if (!this.lostFoundWebForm.value.phoneNumber) return emptyCheck;
        else {
          this.phoneNumberErrorInfo = this.pageLabels?.['errCode.E007'];
          return this.phoneNumberErrorInfo;
        }
      }
      case this.globalDefault.LOST_TIME: {
        if (!this.lostFoundWebForm.value.lostTime) return emptyCheck;
        else {
          this.lostTimeErrorInfo = this.pageLabels?.['errCode.E007'];
          return this.lostTimeErrorInfo;
        }
      }
      case this.globalDefault.LOST_LOCATION: {
        if (!this.lostFoundWebForm.value.lostLocation) return emptyCheck;
        else {
          this.lostLocErrorInfo = this.pageLabels?.['errCode.E007'];
          return this.lostLocErrorInfo;
        }
      }
      case this.globalDefault.DETAILS_OF_LOST_ITEM: {
        if (!this.lostFoundWebForm.value.detailLostItem) return emptyCheck;
        else {
          this.detailsOfLostLocErrorInfo = this.pageLabels?.['errCode.E031'];
          return this.detailsOfLostLocErrorInfo;
        }
      }
      case this.globalDefault.STREET: {
        if (!this.lostFoundWebForm.value.street) return emptyCheck;
        else {
          this.streetErrorMsg = this.pageLabels?.['errCode.E007'];
          return this.streetErrorMsg;
        }
      }
      case this.globalDefault.CITY: {
        if (!this.lostFoundWebForm.value.city) return emptyCheck;
        else {
          this.cityErrorMsg = this.pageLabels?.['errCode.E015'];
          return this.cityErrorMsg;
        }
      }
      case this.globalDefault.TOWN: {
        if (!this.lostFoundWebForm.value.town) return emptyCheck;
        else {
          this.townErrorMsg = this.pageLabels?.['errCode.E015'];
          return this.townErrorMsg;
        }
      }
      case this.globalDefault.PREFECTURE: {
        if (!this.lostFoundWebForm.value.prefecture) return emptyCheck;
        else {
          this.prefectureErrorMsg = this.pageLabels?.['errCode.E015'];
          return this.prefectureErrorMsg;
        }
      }
      case this.globalDefault.DOB: {
        if (!this.lostFoundWebForm.value.dob) return emptyCheck;
        else {
          this.dobErrorInfo = this.pageLabels?.['errCode.E015'];
          return this.dobErrorInfo;
        }
      }
    }
  }
  /**
   * onCheckboxChange - to handle the change of checkbox values
   * @param event The event object
   * @param checkboxType The type of checkbox ('agree' or 'reply')
   */
  onCheckboxChange(event: any, checkboxType: string): void {
    this.checkboxValue = false;

    // Determine the checkbox value based on the event detail
    if (event?.target?.id === checkboxType) {
      this.checkboxValue =
        event?.detail === this.globalDefault.CHECKED ? true : false;
    }

    // Update the corresponding form control based on the checkbox type
    switch (checkboxType) {
      case this.globalDefault.AGREE:
        this.agreeConditionSelected = this.checkboxValue;
        this.lostFoundWebForm.patchValue({
          agree: this.agreeConditionSelected,
        });
        break;
      case this.globalDefault.COUNT_AGREE:
        this.countAgreeSelected = this.checkboxValue;
        this.lostFoundWebForm.patchValue({
          countAgree: this.countAgreeSelected,
        });
        break;
      case this.globalDefault.PRIVACY_AGREE:
        this.privacyAgreeSelected = this.checkboxValue;
        this.lostFoundWebForm.patchValue({
          privacyAgree: this.privacyAgreeSelected,
        });
        break;
      default:
        break;
    }
  }
  /**
   * onRadioButtonLostProperty - to handle the change of lost property radio values
   * @param event The event object
   * @param onRadioButtonLostProperty The type of radio ('Park' or 'Mail')
   */
  onRadioButtonLostProperty(event: any, radioType: any): void {
    if (event?.target?.id == this.globalDefault.SELECTED_LOST_ITEM) {
      this.selectedLostItemRadio = true;
      this.lostFoundWebForm.patchValue({
        selectedLostItemButton: radioType.value,
      });
    } else {
      this.selectedLostPropertyRadio = true;
      this.lostFoundWebForm.patchValue({
        selectedLostPropertyButton: radioType.value,
      });
    }
  }
  /**
   * onRadioButtonMainCategory - to handle the change of Main category radio values
   * @param event The event object
   * @param onRadioButtonMainCategory The type of radio
   */
  onRadioButtonMainCategory(event: any, radioType: any): void {
    if (event?.target?.id == this.globalDefault.SELECTED_LOST_ITEM) {
      const localeInfo = this.locale.getFromUrl();
      const languageCode = localeInfo.language;
      const field = this.lostFoundLanguageData[languageCode];
      this.selectedLostItemRadio = true;
      this.lostFoundWebForm.patchValue({
        selectedLostItemButton: radioType[field.main_category],
        mainCategoryId: radioType?.udx_maincategoryid,
      });
      this.isSubmitButtonEnabled = false;
    } else {
      this.selectedLostPropertyRadio = true;
      this.lostFoundWebForm.patchValue({
        selectedLostPropertyButton: radioType.udx_name,
      });
      this.isSubmitButtonEnabled = false;
    }
    this.isCategorySelected = true;
    this.subCategories(radioType.udx_maincategoryid);
  }

  /**
   * subCategories - Get the sub categories by passing the udxMainCategoryId and sort based on udx_order
   * @param udxMainCategoryId - pass the udxMainCategoryId from the selected main category
   */
  subCategories(udxMainCategoryId: any): void {
    this.spinner.show();
    this.common
      .getSubCategoryData(udxMainCategoryId, this.globalDefault?.LOST_AND_FOUND)
      .subscribe(
        (data: any) => {
          this.subCategoryItems = data?.value;

          this.subCategoryItems?.sort(
            (a: any, b: any) => a?.udx_ordernumber - b?.udx_ordernumber,
          );

          this.subCategoryData = [];

          const optionsRequests = this.subCategoryItems?.map(
            (subCategory: any) =>
              this.common.getSubCategoryOptions(
                subCategory?.udx_subcategoryid,
                this.globalDefault?.LOST_AND_FOUND,
              ),
          );

          forkJoin(optionsRequests).subscribe(
            (responses: any) => {
              this.subCategoryItems?.forEach(
                (subCategory: any, index: number) => {
                  const subCategoryOptions = responses[index].value;

                  const groupedOptions = this.generateSubCategoryOptions(
                    subCategory,
                    subCategoryOptions,
                  );

                  this.subCategoryData.push({
                    subCategory: subCategory,
                    leftOptions: groupedOptions.left,
                    rightOptions: groupedOptions.right,
                  });
                },
              );

              this.createSeparateArraysForSubcategories();

              this.addSubcategories(); // Call this to dynamically generate the FormGroups in the form
              if (
                this.common.getConfirmPage() &&
                !this.isFormSubmittedSuccessfully
              ) {
                this.patchFormSubCategory();
                this.common.setConfirmPage(false);
              }
              // OnPush ancestor (AppComponent) won't see this async update without marking dirty
              this.cdRef.markForCheck();
              this.spinner.hide();
            },
            (error: any) => {
              console.error(error);
              this.spinner.hide();
            },
          );
        },
        (error: any) => {
          console.error(error);
          this.spinner.hide();
        },
      );
  }

  /**
   * generateSubCategoryOptions - sort and formatting the options under the sub categories
   * @param subCategory - pass the particular sub category data
   * @param subCategoryOptions - pass the particular sub category options data
   * @returns
   */
  generateSubCategoryOptions(
    subCategory: any,
    subCategoryOptions: any,
  ): { left: any[]; right: any[] } {
    // Sort options by 'udx_order' to ensure proper display order
    subCategoryOptions.sort((a: any, b: any) => a.udx_order - b.udx_order);

    // Initialize arrays to hold the grouped options for each column
    const leftOptions: any[] = [];
    const rightOptions: any[] = [];

    // Filter options belonging to the current subcategory
    const options = subCategoryOptions.filter(
      (option: any) =>
        option._udx_subcategory_value === subCategory.udx_subcategoryid,
    );

    // Sort options by 'udx_order'
    options.sort((a: any, b: any) => a.udx_order - b.udx_order);
    let i = 1;
    options.forEach((option: any) => {
      if (i % 2 === 1) {
        leftOptions.push(option);
      } else {
        rightOptions.push(option);
      }
      i++;
    });

    return { left: leftOptions, right: rightOptions };
  }

  /**
   * getCategoryHeading - Generate the heading as per the main/sub/options sections
   * @param categoryType - pass the particular categoryType (main/sub/options)
   * @param heading - pass the particular category data as per section
   * @returns
   */
  getCategoryHeading(categoryType: string, heading: any): any {
    const localeInfo = this.locale.getFromUrl();
    const languageCode = localeInfo.language;

    const field = this.lostFoundLanguageData[languageCode];

    if (categoryType === this.globalDefault.MAIN_CATEGORY) {
      return heading[field.main_category];
    } else if (categoryType === this.globalDefault.SUB_CATEGORY) {
      return heading[field.sub_category];
    } else if (categoryType === this.globalDefault.OPTIONS) {
      return heading[field.options];
    }
  }

  /**
   * getAddress-Get edited value from the Address
   */

  getFormData(): void {
    this.lostFoundWebFormData = this.common.getFormData();
  }
  /**
   * onKeyPressEvent - on key press event occur to check the input type
   * @param event - contains the characters entered in input field
   */
  onKeyPressEvent(event: KeyboardEvent): void {
    const isNumeric = /[0-9]/.test(event.key);
    const isControlKey = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
    ].includes(event.key);

    // Allow numeric input or control keys, prevent other characters
    if (!isNumeric && !isControlKey) {
      event.preventDefault();
    }
  }
  /**
   * getCalenderInfo - get the date from the calender
   * @param startDate - pass the startDate
   * @param endDate -  pass the endDate
   */
  getCalenderInfo(startDate: any, endDate: any): any {
    const productObj = {
      product: [],
      products: [],
    };
    // this.addMonthSubscription();
    this.getInitialMonths(startDate, endDate, productObj, 0);
    this.cdr.detectChanges();
  }
  /**
   * getCurrentDateObj - get the user selected date
   */
  getCurrentDateObj(): any {
    this.datePickerData = false;
    this.cdr.detectChanges();
    const selectedDate = this.selectedDate ? this.selectedDate.toString() : '';
    let date;
    if (selectedDate) {
      date = new Date(selectedDate);
    } else {
      date = '';
    }
    this.patchingDate = this.datePipe?.transform(date, 'yyyy-MM-dd');
    this.currentMonthObj = {
      shortDate: this.selectedDate
        ? this.formatShortDate(this.selectedDate)
        : this.pageLabels?.['lostForm.visitDate_ChooseDate'],
      longDate: this.patchingDate
        ? this.patchingDate
        : this.datePipe?.transform(new Date(), 'yyyy-MM-dd'),
      date: this.patchingDate
        ? this.patchingDate
        : this.datePipe?.transform(new Date(), 'yyyy-MM-dd'),
      ariaLabel: this.patchingDate
        ? this.patchingDate
        : this.datePipe?.transform(new Date(), 'yyyy-MM-dd'),
      isoDate: this.patchingDate
        ? this.patchingDate
        : this.datePipe?.transform(new Date(), 'yyyy-MM-dd'),
    };
    this.buildGdsDatePickerCalendarInfo();
    this.cdr.detectChanges();
  }
  /**
   * formatShortDate - display the date format based on the languages
   * @param date - pass the selected date from user
   * @returns
   */
  formatShortDate(date: Date): string {
    const localeInfo = this.locale.getFromUrl();
    if (localeInfo.language === 'en') {
      return this.datePipe?.transform(date, 'MMM dd, yyyy') || '';
    } else {
      return this.datePipe?.transform(date, 'yyyy年MM月dd日') || '';
    }
  }

  /**
   * buildGdsDatePickerCalendarInfo - display the date
   */
  buildGdsDatePickerCalendarInfo(): any {
    this.gdsDatePickerCalendarInfo = {
      shortWeekdays: this.calendarOutputInfo?.info?.shortWeekdays,
      data: { defaultDate: { dayInfo: this.currentMonthObj } },
      timezone: this.appDefault.UPR_TIME_ZONE,
    };
    this.datePickerData = true;
    this.cdr.detectChanges();
  }
  /**
   * getInitialMonths - get initial months
   * @param startDate - pass startDate
   * @param endDate - pass endDate
   * @param item - pass item
   * @param monthCount - pass monthCount
   */
  async getInitialMonths(
    startDate: string,
    endDate: string,
    item: any,
    monthCount: number | undefined,
  ): Promise<void> {
    const monthInfo = {
      startDate: startDate,
      endDate: endDate,
      zone: DateTime.now().zoneName,
      item: item,
      previous: undefined,
      monthCount: monthCount,
      setCurrentToStartDate: false,
    } as IGetMonthProps;
    if (monthInfo) {
      const monthData = await this.gdsCalendarService.getMonth(monthInfo);
      if (monthData) {
        const calendarData = this.gdsCalendarService.getCalendarData(monthData);
        this.calendarOutputInfo = calendarData;
        this.datePickerMonths = calendarData?.months;
      }
    }
    if (Array.isArray(this.datePickerMonths)) {
      for (const month of this.datePickerMonths) {
        for (const day of month?.days ?? []) {
          day.available = true;
        }
      }
    }
    const currentDate = new Date();
    for (const month of this.datePickerMonths) {
      for (const day of month?.days ?? []) {
        // Disable future dates within the current month
        if (month?.number === currentDate?.getMonth() + 1) {
          if (day?.number > currentDate?.getDate()) {
            day.available = false;
          } else {
            day.available = true;
          }
        } else {
          day.available = true;
        }
        day.isPast = false;
      }
      const currentMonth = currentDate?.getMonth() + 1;
      const targetMonth = currentMonth - 3;
      // Check if the first month is month number 4, then set isFuture to false
      if (month?.number === targetMonth) {
        month.isFuture = false;
      } else {
        month.isFuture = true;
      }
    }
    this.buildGdsDatePickerCalendarInfo();
  }

  /**
   * getSelectDate - get selected date and patch in the form
   * @param event - get the selected date
   */
  getSelectDate(event: any): void {
    this.selectionDate = true;
    if (event?.detail?.dayInfo?.isoDate) {
      this.selectedDate = event?.detail?.dayInfo?.isoDate?.substring(0, 10);
    } else {
      this.selectedDate = event?.detail?.dayInfo?.date;
    }
    this.localStorage.setItem('selectedDate', this.selectedDate);
    this.lostFoundWebForm.get('dob')?.patchValue(this.selectedDate);
    this.getCurrentDateObj();
  }
  /**
   * getPostalCodes-Based on postal code will return the prefecture,city,line1
   */

  getPostalCodes(): any {
    this.postalPin = this.lostFoundWebForm.get('postalCode')?.value;
    if (
      this.lostFoundWebForm.value.postalCode?.length !==
      this.ranges.MAX.POSTALCODE
    ) {
      this.cdRef.detectChanges();
      return (this.postalErrorMsg = this.pageLabels?.['errCode.E013']);
    } else {
      this.postalErrorMsg = '';
    }
    this.common.loadPostalLostForm(this.postalPin).subscribe(
      (res: any) => {
        this.validPostalResponse = res;
        this.lostFoundWebForm
          .get('city')
          ?.patchValue(this.validPostalResponse?.[0]?.region);
        this.lostFoundWebForm
          .get('town')
          ?.patchValue(this.validPostalResponse?.[0]?.locality);
        filter(this.prefectureDetailsInfo, (pdiRes: any) => {
          if (pdiRes.name === this.validPostalResponse[0].municipality) {
            this.selectedPrefectureList = pdiRes;
            this.lostFoundWebForm
              ?.get('prefecture')
              ?.patchValue(this.selectedPrefectureList?.name);
            this.cityErrorMsg = '';
            this.townErrorMsg = '';
            this.prefectureErrorMsg = '';
          }
        });
        this.cdRef.detectChanges();
      },
      (err: any) => {
        if (err.error.title === this.globalDefault.NOT_FOUND) {
          this.postalErrorMsg = this.pageLabels?.['errCode.E014'];
          this.lostFoundWebForm.get('city')?.patchValue('');
          this.lostFoundWebForm.get('town')?.patchValue('');
          this.cityErrorMsg = '';
          this.townErrorMsg = '';
          this.prefectureErrorMsg = '';
          this.cdRef.detectChanges();
        }
        if (err.status == this.globalDefault.ERROR_401) {
          this.common.setUser();
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/', environment.cookieSubDomain);
          const redirectUrl = this.common.getOidcRedirectionUrl();
          this.common.redirectToOidcAppEndSession(redirectUrl);
        }
      },
    );
  }
  /**
   * loadPrefecture-It will load the Prefecture
   */

  loadPrefecture(): void {
    this.common.loadPrefectureListLostForm().subscribe(
      (res: any) => {
        this.prefectureDetailsInfo = res;
        this.sortAddress();
        this.showPrefectureDropdownOptions = map(
          this.prefectureDetailsInfo,
          (optionInfo: any) => {
            return { label: optionInfo.name, value: optionInfo };
          },
        );
        this.hidePostalButton = true;
        this.cdRef.detectChanges();
      },
      (errors: any) => {
        if (errors.status == this.globalDefault.ERROR_401) {
          this.common.setUser();
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll('/', environment.cookieSubDomain);
          const redirectUrl = this.common.getOidcRedirectionUrl();
          this.common.redirectToOidcAppEndSession(redirectUrl);
        }
      },
    );
  }
  /**
   * sortAddress-Sort Address based on Iso-Numeric
   */
  sortAddress(): void {
    if (Array.isArray(this.prefectureDetailsInfo)) {
      this.prefectureDetailsInfo?.sort((a: any, b: any) => {
        const extractNumeric = (obj: any): string =>
          (obj.iso_numeric || '').replace(/^\D+/g, ''); // Specify the return type here
        const a1 = parseFloat(extractNumeric(a));
        const b1 = parseFloat(extractNumeric(b));
        return a1 - b1;
      });
    }
  }

  /**
   * onContinue - Redirect to lost found confirmation screen and pass the form data
   */
  onContinue(): any {
    this.localeInfo = this.locale.getFromUrl();
    this.lostFoundCreation = false;
    this.lostFoundConfirmPage = true;
    this.common.setFormData(this.lostFoundWebForm);
    this.common.setFormSubmitted(false);
    this.common.changeRoute(this.appRoutes.LOST_FOUND_CONFIRM);
  }

  /**
   * onBackBtn - to retail values once user click on back button
   * @param flag
   */
  onBackBtn(flag: any): void {
    this.lostFoundWebForm = flag?.lostFoundForm;
    this.lostFoundCreation = true;
    this.lostFoundConfirmPage = false;
    this.location.go(
      '/' +
        this.localeInfo.language +
        '/' +
        this.localeInfo.country +
        '/' +
        this.appRoutes.LOST_FOUND,
    );
    this.common.scrollTop();
    this.dob = this.localStorage.getItem('selectedDate');
    this.getCurrentDateObj();
    this.lostFoundWebForm.get('dob')?.patchValue(this.dob);
  }

  /**
   * onRadioButtonOptions - On selection of options radio items
   * @param event - pass the event
   * @param item  - pass the particular radio button
   * @param sectionIndex - pass the selected radio button index
   */
  onRadioButtonOptions(event: any, item: any, sectionIndex: number): void {
    console.log(event);

    const subcategories = this.lostFoundWebForm.get(
      'subcategories',
    ) as FormArray;
    const selectedOptionControl = subcategories
      .at(sectionIndex)
      ?.get('selectedOption');

    if (selectedOptionControl) {
      selectedOptionControl.setValue(item.udx_optionid);
    }
  }

  /**
   * onItemChange - Function to handle changes in radio button selections
   * @param groupName
   * @param optionId
   * @param optionName
   */
  onItemChange(groupName: string, optionId: string, optionName: string): void {
    const subcategories = this.lostFoundWebForm.get(
      'subcategories',
    ) as FormArray;
    const subcategoryIndex = subcategories.controls.findIndex(
      (control: AbstractControl) => {
        const formGroup = control as FormGroup;
        return formGroup.get('subCategoryName')?.value === groupName;
      },
    );

    if (subcategoryIndex !== -1) {
      const subCategoryGroup = subcategories.at(subcategoryIndex) as FormGroup;

      // Set the selected option and option ID for this subcategory
      subCategoryGroup.get('selectedOption')?.setValue(optionName);
      subCategoryGroup.get('selectedOptionId')?.setValue(optionId);
    }

    // After each change, check the form validity
    this.checkFormValidity();
  }

  /**
   * selectedRadioValue - To retrieve the selected radio values
   */
  get selectedRadioValue(): any {
    return this.selectedRadioValues;
  }

  /**
   * isOptionSelected - Maintain the selected state from conf screen to creation screen
   * @param subCategoryName
   * @param optionName
   * @returns
   */
  isOptionSelected(subCategoryName: string, optionName: string): string {
    const selectedSubcategory =
      this.lostFoundWebForm?.value?.subcategories?.find(
        (subcat: any) => subcat.subCategoryName === subCategoryName,
      );
    return selectedSubcategory &&
      selectedSubcategory.selectedOption === optionName
      ? 'true'
      : '';
  }

  /**
   * isFormValid - Function to check if all options are selected and if the form is valid
   * @returns
   */
  isFormValid(): boolean {
    const subcategoriesArray = this.lostFoundWebForm.get(
      'subcategories',
    ) as FormArray;

    const allOptionsSelected = subcategoriesArray.controls.every(
      (subCategoryControl) => {
        const control = subCategoryControl as FormGroup;
        const selectedOption = control.get('selectedOption');

        return (
          selectedOption?.value !== null &&
          selectedOption?.value !== undefined &&
          selectedOption?.valid
        );
      },
    );

    // Return true if the form is valid and all subcategory options have been selected
    return this.lostFoundWebForm.valid && allOptionsSelected;
  }

  /**
   * checkFormValidity - Check if all subcategories have a selected option
   */
  checkFormValidity(): void {
    const anySelected = this.lostFoundWebForm
      .get('subcategories')
      ?.value.some((subCategory: any) => {
        return (
          subCategory.selectedOption !== null &&
          subCategory.selectedOption !== ''
        );
      });

    // Enable the continue button if at least one sub-category is selected
    this.enableSubmitButton(anySelected);
  }

  /**
   * enableSubmitButton - Enable the continue button based on the selection state
   * @param enable
   */
  enableSubmitButton(enable: boolean): void {
    this.isSubmitButtonEnabled = enable;
    this.lostFoundWebForm.updateValueAndValidity();
  }
  // Method to check the condition for showing subcategories
  shouldDisplaySubCategories(): boolean {
    return (
      this.subCategoryItems?.length > 0 &&
      this.subCategoryOptions?.some(
        (item) => item.leftOptions?.length > 0 || item.rightOptions?.length > 0,
      )
    );
  }
  getMainCategoryName(): string {
    const localeInfo = this.locale.getFromUrl();
    const languageCode = localeInfo.language;
    const field = this.lostFoundLanguageData[languageCode];
    return field?.main_category;
  }

  getSubCategoryName(): string {
    const localeInfo = this.locale.getFromUrl();
    const languageCode = localeInfo.language;
    const field = this.lostFoundLanguageData[languageCode];
    return field?.sub_category;
  }

  getOptionName(): string {
    const localeInfo = this.locale.getFromUrl();
    const languageCode = localeInfo.language;
    const field = this.lostFoundLanguageData[languageCode];
    return field?.options;
  }
}
